
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lessons",
      function () {
        return require("private-next-pages/lessons.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lessons"])
      });
    }
  